export const ErrorMapper: Record<string, string> = {} as const
export const DefaultErrorMessages = {
  Default: 'Ocorreu um erro. Por favor, tente novamente mais tarde.',
  Network: 'Ocorreu um erro de rede. Você está conectado à internet?',
  Server: 'Estamos com problemas internos. Por favor, tente novamente mais tarde.',
} as const
